import { httpsCallable } from "firebase/functions";
export class AccountStatusApiService {
    constructor(functions) {
        this.getAccountStatus = async (accountId) => {
            try {
                const getAccountStatus = httpsCallable(this.functions, 'getAccountStatus');
                const result = await getAccountStatus({ "accountId": accountId });
                const response = result.data;
                console.log("firebaseFunctionsApi.getAccountStatus response:", response);
                return response;
            }
            catch (e) {
                console.error("UserAccountsApi.getAccounts error:", e);
                return undefined;
            }
        };
        this.functions = functions;
    }
}
